// purchasingService.js
// API service for purchase orders and purchasing dashboard

import { HTTPService } from './httpService';

const API = new HTTPService();

// ============================================================================
// Purchase Orders
// ============================================================================

export const getPurchaseOrders = async (installerId, filters = {}) => {
    const params = { installerId, ...filters };
    const { data } = await API.get('/api/purchase-orders', params);
    return data.data || data;
};

export const getPurchaseOrder = async (poId) => {
    const { data } = await API.get(`/api/purchase-orders/${poId}`);
    return data.data || data;
};

export const createPurchaseOrder = async (poData) => {
    const { data } = await API.post('/api/purchase-orders', poData);
    return data;
};

export const updatePurchaseOrder = async (poId, poData) => {
    const { data } = await API.patch(`/api/purchase-orders/${poId}`, poData);
    return data;
};

// ============================================================================
// PO Lines
// ============================================================================

export const addPOLine = async (poId, lineData) => {
    const { data } = await API.post(`/api/purchase-orders/${poId}/lines`, lineData);
    return data;
};

export const updatePOLine = async (lineId, lineData) => {
    const { data } = await API.patch(`/api/purchase-order-lines/${lineId}`, lineData);
    return data;
};

export const deletePOLine = async (lineId) => {
    const { data } = await API.delete(`/api/purchase-order-lines/${lineId}`);
    return data;
};

// ============================================================================
// PO Actions
// ============================================================================

export const submitPO = async (poId) => {
    const { data } = await API.post(`/api/purchase-orders/${poId}/submit`);
    return data;
};


export const cancelPO = async (poId) => {
    const { data } = await API.post(`/api/purchase-orders/${poId}/cancel`);
    return data;
};

export const receivePO = async (poId, lines = null) => {
    const body = lines ? { lines } : {};
    const { data } = await API.post(`/api/purchase-orders/${poId}/receive`, body);
    return data;
};

// ============================================================================
// Purchasing Dashboard
// ============================================================================

export const getDemandPreview = async (productId, installerId, locationId = null) => {
    const params = { installerId };
    if (locationId && locationId !== 'all') params.locationId = locationId;
    const { data } = await API.get(`/api/inventory/demand-preview/${productId}`, params);
    return data.data || data;
};

export const createDraftPOs = async (taskIds, installerId, userId = null) => {
    const body = { taskIds, installer_id: installerId };
    if (userId) body.created_by_user_id = userId;
    const { data } = await API.post('/api/purchasing/create-draft-pos', body);
    return data;
};

// Default export for convenience
const PurchasingAPI = {
    getPurchaseOrders,
    getPurchaseOrder,
    createPurchaseOrder,
    updatePurchaseOrder,
    addPOLine,
    updatePOLine,
    deletePOLine,
    submitPO,
    cancelPO,
    receivePO,
    getDemandPreview,
    createDraftPOs
};

export default PurchasingAPI;
